// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"Spinner_spinnerContainer__3udEh","loadingSpinner":"Spinner_loadingSpinner__26Meh","spinner":"Spinner_spinner__1KA-_"};